<template>
  <JournalPage />
</template>

<script setup>
import { useJournalStore } from '~/stores/journal';

const { $cmsApi } = useNuxtApp();
const journalStore = useJournalStore();
const route = useRoute();

if (route.query.category) {
  journalStore.setCategory(route.query.category);
}

await useAsyncData(async () => {
  let mainArticle = journalStore.mainArticle;
  let articles = journalStore.articles;
  let leadgenPages = journalStore.leadgenPages;
  let popularArticles = journalStore.popularArticles;
  let categories = journalStore.categories;

  if (!mainArticle) {
    mainArticle = await $cmsApi.get('/articles/main');
    journalStore.setMainArticle(mainArticle);
  }

  if (!categories.length) {
    categories = await $cmsApi.get('/articles/categories');
    journalStore.setCategories(categories);
  }

  if (!popularArticles.length) {
    popularArticles = await $cmsApi.get('/articles/most-popular');
    journalStore.setPopularArticles(popularArticles);
  }

  if (!articles.length && !journalStore.isLeadgenPageCategory) {
    articles = await $cmsApi.get('/cards', journalStore.filterParams);
    journalStore.setArticles(articles);
  }

  if (
    !leadgenPages.length &&
    (!journalStore.category || journalStore.isLeadgenPageCategory)
  ) {
    leadgenPages = await $cmsApi.get(
      '/leadgen-pages',
      journalStore.leadgenFilterParams
    );
    journalStore.setLeadgenPages(leadgenPages);
  }

  return { mainArticle, articles, leadgenPages, popularArticles, categories };
});

useHead({
  title: 'Proxify Journal - Careers in tech',
  meta: [
    {
      key: 'og:title',
      property: 'og:title',
      content: 'Proxify Journal - Careers in tech',
    },
    {
      key: 'description',
      name: 'description',
      property: 'description',
      content:
        'Explore our blog for expert advice on building successful remote tech careers. Stay updated on the latest trends, tips, and resources to thrive in the remote tech job market.',
    },
    {
      key: 'og:description',
      property: 'og:description',
      content:
        'Explore our blog for expert advice on building successful remote tech careers. Stay updated on the latest trends, tips, and resources to thrive in the remote tech job market.',
    },
  ],
});
</script>
